import { Box, Grid, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { SettingsEditProps } from './settings-edit.types';
import { CompanySettingsDataForm } from './settings-edit-page.types';
import { EmployeeMutableUntilHoursField } from './components/employee-mutable-until-hours-field/employee-mutable-until-hours-field';
import { SettingSwitch } from './components/setting-switch/setting-switch';

export const SettingsEdit = (props: SettingsEditProps) => {
  const { control } = useFormContext<CompanySettingsDataForm>();
  const { offersEmployeeWork } = props.companyData;
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Grid container spacing={4}>
      <Grid item xs={4}>
        <SwitchesContainer>
          {offersEmployeeWork ? (
            <>
              <SettingSwitch
                control={control}
                name="requiresEmployeeContract"
                label={t('settings-edit-page.employee-contract-requested-label')}
                disabled={!offersEmployeeWork}
              />
              <SettingSwitch
                control={control}
                name="requiresEmployeeCertificates"
                label={t('settings-edit-page.employee-certificates-requested-label')}
                disabled={!offersEmployeeWork}
              />
            </>
          ) : null}
          <SettingSwitch
            control={control}
            name="allowShiftStartTimeOverride"
            label={t('settings-edit-page.allow-shift-start-time-override-label')}
            tooltipDescription={t(
              'settings-edit-page.allow-shift-start-time-override-tooltip-description'
            )}
            iconTestId="allow-shift-start-time-override-tooltip-icon"
          />
          <SettingSwitch
            control={control}
            name="allowShiftEndTimeOverride"
            label={t('settings-edit-page.allow-shift-end-time-override-label')}
            tooltipDescription={t(
              'settings-edit-page.allow-shift-end-time-override-tooltip-description'
            )}
            iconTestId="allow-shift-end-time-override-tooltip-icon"
          />
          <SettingSwitch
            control={control}
            name="allowEditCheckoutHours"
            label={t('settings-edit-page.allow-edit-checkout-times.switch-label')}
            tooltipDescription={t(
              'settings-edit-page.allow-edit-checkout-times.tooltip-description'
            )}
            iconTestId="allow-edit-checkout-hours-tooltip-icon"
          />
        </SwitchesContainer>
      </Grid>
      {offersEmployeeWork ? (
        <Grid item xs={4}>
          <EmployeeMutableUntilHoursField
            name="employeeMutableUntilHours"
            label={t('settings-edit-page.employee-mutable-until-minutes-label')}
            placeholder="0"
            control={control}
          />
        </Grid>
      ) : null}
      <Grid item xs={4} />
    </Grid>
  );
};

const SwitchesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  maxWidth: '400px',
  width: '100%',
}));
